import { MonoTypeOperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

export function exists<T>(): MonoTypeOperatorFunction<T> {
  return (input$) => input$.pipe(filter((value) => !!value));
}
